import { Component } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { SemCallsV5Component } from '../sem-calls-v5/sem-calls-v5.component';
import * as Highcharts from 'highcharts';
import * as Moment from 'moment';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import {
	HIGHCHARTS_LEGEND_ALIGN,
	HIGHCHARTS_LEGEND_LAYOUT,
	HIGHCHARTS_LEGEND_VERTICAL_ALIGN
} from '../../../analytics/constants/analytics.constants';

@Component({
	selector: 'app-sem-calls-v6',
	templateUrl: './sem-calls-v6.component.html',
	styleUrls: ['./sem-calls-v6.component.css']
})
export class SemCallsV6Component extends SemCallsV5Component {
	answeredCallsText = 'Answered';
	missedCallsText = 'Missed';
	defaultCount = 8;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
	}
	// function to build charts series object which will be passed to highchats
	protected buildChartSeriesObj(graphData: any) {
		const chartSeries: any = [];
		// series 1 : answered calls
		const answeredCalls: any = {};
		let seriesIndex = 0;
		let colorIndex = 0;
		answeredCalls.type = this.chartConfig.seriesConfig[seriesIndex].type;
		answeredCalls.name = this.chartConfig.seriesConfig[seriesIndex].seriesName;
		answeredCalls.color = this.getColorFromColorConfigObj(this.chartConfig.seriesConfig[seriesIndex].colorConfig, 1);
		answeredCalls.legendIndex = this.chartConfig.seriesConfig[seriesIndex].legendIndex;
		answeredCalls.zIndex = 1;
		answeredCalls.marker = {
			symbol: this.chartConfig.seriesConfig[seriesIndex].marker.symbol,
			enabled: this.chartConfig.seriesConfig[seriesIndex].marker.enabled,
			fillColor: this.getColorFromColorConfigObj(this.chartConfig.seriesConfig[seriesIndex].colorConfig),
			lineColor:
				this.chartConfig.seriesConfig[seriesIndex].lineColorConfig !== undefined
					? this.getColorFromColorConfigObj(this.chartConfig.seriesConfig[seriesIndex].lineColorConfig)
					: '#ffffff',
			lineWidth: this.chartConfig.seriesConfig[seriesIndex].marker.lineWidth,
			states: {
				hover: {
					fillColor: this.getColorFromColorConfigObj(this.chartConfig.seriesConfig[seriesIndex].colorConfig, 1)
				},
				halo: {
					opacity: this.chartConfig.seriesConfig[seriesIndex].colorConfig.opacity
						? this.chartConfig.seriesConfig[seriesIndex].colorConfig.opacity
						: 0.3
				},
				lineColor:
					this.chartConfig.seriesConfig[seriesIndex].lineColorConfig !== undefined
						? this.getColorFromColorConfigObj(this.chartConfig.seriesConfig[seriesIndex].lineColorConfig, 1)
						: '#ffffff'
			}
		};

		// series 2 : missed calls
		const missedCalls: any = {};
		seriesIndex = 1;
		colorIndex = 1;
		missedCalls.type = this.chartConfig.seriesConfig[seriesIndex].type;
		missedCalls.name = this.chartConfig.seriesConfig[seriesIndex].seriesName;
		missedCalls.color = this.getColorFromColorConfigObj(this.chartConfig.seriesConfig[seriesIndex].colorConfig, 1);
		missedCalls.legendIndex = this.chartConfig.seriesConfig[seriesIndex].legendIndex;
		missedCalls.zIndex = 2;
		missedCalls.marker = {
			symbol: this.chartConfig.seriesConfig[seriesIndex].marker.symbol,
			enabled: this.chartConfig.seriesConfig[seriesIndex].marker.enabled,
			fillColor: this.getColorFromColorConfigObj(this.chartConfig.seriesConfig[seriesIndex].colorConfig),
			lineColor:
				this.chartConfig.seriesConfig[seriesIndex].lineColorConfig !== undefined
					? this.getColorFromColorConfigObj(this.chartConfig.seriesConfig[seriesIndex].lineColorConfig)
					: '#ffffff',
			lineWidth: this.chartConfig.seriesConfig[seriesIndex].marker.lineWidth,
			states: {
				hover: {
					fillColor: this.getColorFromColorConfigObj(this.chartConfig.seriesConfig[seriesIndex].colorConfig, 1)
				},
				halo: {
					opacity: this.chartConfig.seriesConfig[seriesIndex].colorConfig.opacity
						? this.chartConfig.seriesConfig[seriesIndex].colorConfig.opacity
						: 0.3
				},
				lineColor:
					this.chartConfig.seriesConfig[seriesIndex].lineColorConfig !== undefined
						? this.getColorFromColorConfigObj(this.chartConfig.seriesConfig[seriesIndex].lineColorConfig, 1)
						: '#ffffff'
			}
		};

		// getting filter values
		let minCallDurationFilter: any;
		let maxCallDurationFilter: any;
		switch (Number(this.selectedValue)) {
			case 4:
				minCallDurationFilter = 60;
				maxCallDurationFilter = false;
				break;
			case 3:
				minCallDurationFilter = 30;
				maxCallDurationFilter = 60;
				break;
			case 2:
				minCallDurationFilter = 0;
				maxCallDurationFilter = 30;
				break;
			case 1:
			default:
				minCallDurationFilter = false;
				maxCallDurationFilter = false;
		}

		// creating graph data with tooltip for both series
		const answeredSeriesData = [];
		const missedSeriesData = [];
		for (let i = 0; i < graphData.length; i++) {
			// answered calls
			if (graphData[i].answeredCalls > 0) {
				let time = graphData[i].time.split(':');
				time = (Number(time[0]) * 3600 + Number(time[1]) * 60 + Number(time[2])) * 1000;
				let callDurationsTooltip = graphData[i].callDurations.split(',').filter((value: any) => {
					return (
						(minCallDurationFilter == false || value > minCallDurationFilter) &&
						(maxCallDurationFilter == false || value <= maxCallDurationFilter)
					);
				});

				if (callDurationsTooltip.length > 0) {
					const isPlural = callDurationsTooltip.length > 1 ? 's' : '';
					callDurationsTooltip = callDurationsTooltip
						.map((duration: any, index) => {
							const displayIndex = index + 1;
							return (
								'<div class="sem_calls_duration_v6">DURATION ' +
								(isPlural ? displayIndex : '') +
								': ' +
								Highcharts.dateFormat('%H:%M:%S', duration * 1000) +
								'<br/></div>'
							);
						})
						.join('');
					const tooltip =
						"<div class='sem_calls_v6'>" + graphData[i].answeredCalls + ' ANSWERED</div>' + callDurationsTooltip;
					answeredSeriesData.push([graphData[i].dateObj * 1000, time, tooltip]);
				}
			}
			// missed Calls
			if (graphData[i].missedCalls > 0) {
				let time = graphData[i].time.split(':');
				time = (Number(time[0]) * 3600 + Number(time[1]) * 60 + Number(time[2])) * 1000;
				const tooltip = "<div class='sem_calls_missed_v6'>" + graphData[i].missedCalls + ' MISSED</div>';
				missedSeriesData.push([graphData[i].dateObj * 1000, time, tooltip]);
			}
		}
		answeredCalls.data = answeredSeriesData;
		missedCalls.data = missedSeriesData;

		chartSeries.push(answeredCalls);
		chartSeries.push(missedCalls);
		return chartSeries;
	}

	drawGraph() {
		const xaxisLabelFormat = this.chartConfig.graphConfig.xAxisConfig.labelFormat
			? this.chartConfig.graphConfig.xAxisConfig.labelFormat
			: '%e-%b';
		const stepCount = this.calculateStepCountByDate();
		const margin = this.chartConfig.graphConfig.margin ? this.chartConfig.graphConfig.margin : [10, 50, 70, 100];
		const xMin = Moment.utc(this.analyticsDataModel.startDate.format('YYYYMMDD'), 'YYYYMMDD').unix() * 1000;
		let xMax = Moment.utc(this.analyticsDataModel.endDate.format('YYYYMMDD'), 'YYYYMMDD').unix() * 1000;

		if (this.analyticsDataModel.startDate.format('YYYYMMDD') === this.analyticsDataModel.endDate.format('YYYYMMDD')) {
			xMax = xMin;
		}

		this.chartObj = Highcharts.chart({
			chart: {
				renderTo: this.graphElement.nativeElement,
				type: 'scatter',
				height: '310px',
				marginTop: 65,
				marginRight: 30,
				spacingLeft: 0
			},
			title: {
				text: null
			},
			subtitle: {
				text: null
			},
			xAxis: {
				min: xMin,
				max: xMax,
				tickInterval: 24 * 3600 * 1000,
				labels: {
					formatter: function () {
						return Moment.utc(this.value).format(xaxisLabelFormat);
					},
					style: {
						fontFamily: 'Lora !important',
						fontStyle: 'italic !important',
						color: '#262626',
						fontWeight: 'normal',
						'font-size': '12px',
						textOverflow: 'none'
					},
					step: stepCount
				},
				lineWidth: 0,
				lineColor: 'transparent',
				tickLength: 0,
				showFirstLabel: true,
				showLastLabel: true,
				endOnTick: false,
				startOnTick: false
			},
			tooltip: {
				useHTML: true,
				borderColor: 'rgba(221, 225, 227, 0.75)',
				backgroundColor: '#f7f7f7',
				borderRadius: 4,
				borderWidth: 0,
				formatter: function () {
					return (
						'<div class="sem_calls_tooltip"><div class="primary-color">' +
						Highcharts.dateFormat('%m/%d/%Y', this.x) +
						' - ' +
						Highcharts.dateFormat('%l:%M:%S %p', this.y) +
						'</div>' +
						this.point['tooltip'] +
						'</div>'
					);
				}
			},
			yAxis: [
				{
					title: {
						text: ''
					},
					gridLineWidth: 0,
					allowDecimals: false,
					min: 0,
					max: 24 * 3600 * 1000,
					tickInterval: 4 * 3600 * 1000,
					type: 'datetime',
					offset: 20,
					labels: {
						formatter: function () {
							return Highcharts.dateFormat('%l:%M %p', Number(this.value));
						},
						style: {
							fontFamily: 'Lora !important',
							fontStyle: 'italic !important',
							color: '#262626',
							fontWeight: 'normal',
							'font-size': '12px',
							textOverflow: 'none'
						}
					}
				}
			],
			credits: {
				enabled: false
			},
			plotOptions: {
				series: {
					enableMouseTracking: true,
					keys: ['x', 'y', 'tooltip'],
					events: {
						legendItemClick: (el) => {
							if (el.target['userOptions'].name === this.answeredCallsText) {
								this.graphFilterDisabled = el.target.visible;
							}

							if (
								(el.target['userOptions'].name === this.answeredCallsText &&
									el.target.visible &&
									!el.target.chart.legend.allItems[1].visible) ||
								(el.target['userOptions'].name === this.missedCallsText &&
									el.target.visible &&
									!el.target.chart.legend.allItems[0].visible)
							) {
								el.target.chart.yAxis[0].update({ visible: false });
								el.target.chart.xAxis[0].update({ visible: false });
							} else {
								el.target.chart.yAxis[0].update({ visible: true });
								el.target.chart.xAxis[0].update({ visible: true });
							}
						}
					},
					states: {
						inactive: {
							opacity: 1
						}
					}
				},
				scatter: {
					marker: {
						radius:
							this.chartConfig.seriesConfig[0].marker && this.chartConfig.seriesConfig[0].marker.symbolRadius
								? this.chartConfig.seriesConfig[0].marker.symbolRadius
								: 12
					}
				}
			},
			legend: {
				layout: HIGHCHARTS_LEGEND_LAYOUT[this.chartConfig.graphConfig.legendConfig.layout] || 'horizontal',
				align: HIGHCHARTS_LEGEND_ALIGN[this.chartConfig.graphConfig.legendConfig.align] || 'center',
				verticalAlign:
					HIGHCHARTS_LEGEND_VERTICAL_ALIGN[this.chartConfig.graphConfig.legendConfig.verticalAlign] || 'bottom',
				floating: false,
				symbolPadding: 5,
				itemWidth: 120,
				symbolRadius:
					this.chartConfig.seriesConfig[0].marker && this.chartConfig.seriesConfig[0].marker.symbolRadius
						? this.chartConfig.seriesConfig[0].marker.symbolRadius
						: 12,
				x: 40,
				y: 3,
				itemStyle: this.chartConfig.graphConfig.legendConfig.itemStyle
					? this.chartConfig.graphConfig.legendConfig.itemStyle
					: {},
				itemHiddenStyle: this.chartConfig.graphConfig.legendConfig.itemHiddenStyle
					? this.chartConfig.graphConfig.legendConfig.itemHiddenStyle
					: {},
				itemHoverStyle: this.chartConfig.graphConfig.legendConfig.itemHoverStyle
					? this.chartConfig.graphConfig.legendConfig.itemHoverStyle
					: {}
			},
			series: this.graphObj.series
		});
	}

	calculateStepCountByDate() {
		const dataLength = this.analyticsDataModel.endDate.diff(this.analyticsDataModel.startDate, 'days') + 1;
		if (dataLength <= 31) {
			return 1;
		} else if (dataLength <= 300 && dataLength >= 200) {
			return 10;
		} else if (dataLength >= 300) {
			return 25;
		} else {
			return 5;
		}
	}
}
